import { Colors as C } from '../../constants/Colors.js';

/** Superficies oscuras compartidas (Comunidad, Mercado, Subastas). */
export const MP_SURF = {
  pageBg: C.dark,
  drawerBg: '#0e0e14',
  card: C.darkMid,
  cardBorder: '0.5px solid rgba(255,255,255,0.08)',
  text: '#fff',
  textMuted: 'rgba(255,255,255,0.5)',
  textDim: 'rgba(255,255,255,0.35)',
  textSoft: 'rgba(255,255,255,0.45)',
  divider: 'rgba(255,255,255,0.08)',
  inputBg: 'rgba(255,255,255,0.06)',
  inputBorder: '0.5px solid rgba(255,255,255,0.12)',
  chipInactiveBg: 'rgba(255,255,255,0.04)',
  chipInactiveBorder: 'rgba(255,255,255,0.12)',
  chipInactiveColor: 'rgba(255,255,255,0.55)',
  chipActiveBg: 'rgba(200,168,75,0.14)',
  chipActiveColor: C.gold,
  labelMuted: 'rgba(255,255,255,0.35)',
};
